<template>
  <lf-table
    v-if="Object.keys(data).length"
    :columns="cols"
    :data="[data]"
    class="block w-full overflow-x-auto p-3 whitespace-nowrap"
    @click.stop
  />
  <div v-else class="mb-2 w-full p-3 text-center">
    <hr />
    <span>No Data Available</span>
  </div>
</template>
<script setup lang="ts">
import { formatMoney } from "@/helpers/formatting";

import LfTable from "@/components/ui/table/LfTable.vue";

import type { IDealsColumn } from "@/models/applications";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: true,
    default: "",
  },
});

const nonCurrencyTables = [
  "Total Deposits Count By Month",
  "NSF Count By Month",
  "NSF Transactions Returned or Not Paid Count By Month",
  "Nsf Transactions Paid or Negative Balance Count by Month",
  "Recurring vs Episodic Outflows by Month",
  "Recurring vs Episodic Inflows by Month",
];

const cols: IDealsColumn[] = Object.keys(props.data).map((key) => ({
  label: key,
  key: key,
  formatter: !nonCurrencyTables.includes(props.title) ? formatMoney : undefined,
}));
</script>
